 <template>
  <div class="app-mercedes">
    <div>
      <nav
        class="navbar navbar-light navbar-expand-lg p-0 border-0 shadow"
        style="background: #212121;height:50px"
      >
        <div class="container">
          <a href class="navbar-brand router-link-active" style="display:flex">
            <img :src="peu" width="140px" alt />
            <img :src="sep" width="auto" alt style="margin:0rem 1rem" />
            <router-link to="/mercedes/commercial" style="margin-top: auto;margin-bottom: auto;">
              <img :src="commer" width="140px" alt style="cursor:pointer" />
            </router-link>
            <span style="padding: 0.5rem 1rem 0rem 1rem"></span>
          </a>
        </div>
      </nav>
    </div>
    <!-- banner -->
    <section class="commercialslider">
      <el-carousel :interval="5000" arrow="never">
        <el-carousel-item v-for="item in 1" :key="item">
          <div class="container">
            <div class="row">
              <div class="sliderinfo">
                <!-- <h5>
                  Efficiency! 
                  <span>CLASS</span>
                </h5>
                <div class="line"></div> -->
                <h2>Efficiency! <br> Just delivered</h2>
                <!-- <ul> 
                  <li>15 Seat Capacity</li>
                  <li>Independent Dual Air Conditioner System</li>
                </ul> -->
                <h5>The Mercedes-Benz Sprinter</h5>
                <!-- <div style="margin-top:7%">
                  <el-button
                    type="info"
                    style="border: 1.5px solid #00ADEF;background:#00ADEF"
                    @click=" acros"
                  >
                    EXPLORE MODEL
                    <i class="el-icon-arrow-right" style="padding-left:5%"></i>
                  </el-button>
                
                </div> -->
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>
    <div class="py-5" style="margin:2rem">
      <div class="container">
        <div class>
          <div style="display:flex" v-for="(promo, i) in homecars" :key="i">
            <div class="carline"></div>

            <div class="row">
              <div class="col-sm-6 col-md-12 col-lg-12" style="margin:0rem 2rem;">
                <h5 class="carname text-uppercase">{{promo.name}}</h5>
                <div class="row">
                  <div
                    class="text-center py-3"
                    v-for="(promocars, i) in promo.cars"
                    :key="i"
                    style="margin-right:1rem"
                  >
                    <router-link
                      class="carroute"
                      :to="'/commercial/' + promocars.url_dash + '/' + promocars.mask"
                    >
                      <img
                        :src="promocars.filename"
                        alt
                        width="200px"
                        style="background:#FAFAFA"
                        height="112px"
                      />
                      <!-- <div class="brand"><p class="brandname">C-Class Coupé</p></div> -->
                      <div class="brand">
                        <p class="brandname">{{promocars.name}}</p>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container py-5">
      <div class="row save">
        <div class="comfort">
          <div class="py-3 comfortinfo">
            <h2>THE MERCEDES-BENZ SPRINTER BUS</h2>
            <p style="font-weight:bold">
              Immediate delivery whilst stocks last
              <br /> <br />
              <span>AVAILABLE IN STOCK</span>
            </p>
            <div class="pvbtn" style="margin-top:0%">
              <el-button
                type="info"
                style="border: 1.5px solid #00ADEF;background:#00ADEF"
                @click="contact"
              >
                ORDER NOW
                <i class="el-icon-arrow-right" style="padding-left:5%"></i>
              </el-button>
              <!-- <el-button class="text" type="text">DISCOVER PEUGEOT</el-button> -->
            </div>
          </div>
        </div>

        <!-- <div class="comfort d-none d-md-block"></div>
        <div class="py-3 comfortinfo">
          <h2>Save up to 13.4% off the latest EQC model now</h2>
          <p>You could have up to 13.4% OFF the latest Mercedes-Benz Actros model by signing up to the official pre-order list at our head office.</p>
          <div style="margin-top:0%">
            <el-button type="info" style="border: 1.5px solid #00ADEF;background:#00ADEF" @click="contact">
              PRE-ORDER MODEL
              <i class="el-icon-arrow-right" style="padding-left:5%"></i>
            </el-button>
           
          </div>
        </div>-->
      </div>
    </div>

    <div class="bg-grey" style="padding-top:3rem">
      <div class="container">
        <core></core>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import CoreValues from "../../components/Core.vue";
var peu = require("../../assets/img/mblogo.svg");
var sep = require("../../assets/img/sep.svg");
var model = require("../../assets/img/model.png");
var commer = require("../../assets/img/commer.svg");
var comfort = require("../../assets/img/comfort.png");

export default {
  name: "Commercial",
  components: {
    core: CoreValues
  },
  data() {
    return { peu, sep, commer, comfort, model, homecars: [] };
  },
  metaInfo() {
    return {
      title: "Commercial"
    };
  },
  computed: {},
  methods: {
    details() {
      this.$router.push("/commercial/details");
    },

    fetch_cars() {
      var self = this;

      axios.get(APIURL + "brandproduct/mercedes/commercial").then(response => {
        this.homecars = response.data.data;
        console.log(this.homecars);
        this.$nextTick(function() {
          $(".cardesign").owlCarousel({
            loop: false,
            items: 10,
            autoWidth: true,
            responsiveClass: true,
            margin: 10
          });
        });
      });
    },
    acros() {
      this.$router.push("/commercial/sprinter-ambulance/T3ICRV");
    },
    contact() {
      this.$router.push("/contact");
    }
  },
  created() {
    this.fetch_cars();
  }
};
</script>
